export default "__VITE_ASSET__affcb187__$_?component__"